import { call, put, takeEvery } from "redux-saga/effects";
import PortalService from "services/PortalService";
import {
  SEARCH_CODE_PORTAL,
  GET_SEARCH_RESULT,
  GET_CAPCHA,
  DOWNLOAD_FILE,
} from "store/portal/actionTypes";
import { errorMessage } from "helpers/utils";
import {
  searchCodePortalSuccess,
  searchCodePortalFail,
  getSearchResultSuccess,
  getSearchResultFail,
  getCapchaSuccess,
  getCapchaFail,
  downloadFileSuccess,
  downloadFileFail,
} from "./actions";
function* getCapcha() {
  try {
    const response = yield call(PortalService.getCapcha);
    yield put(getCapchaSuccess(response));
  } catch (error) {
    yield put(getCapchaFail(error));
  }
}
function* searchCodePortal({ payload }) {
  try {
    const response = yield call(PortalService.searchCodePortal, payload);
    if (response.status === false) {
      yield put(searchCodePortalFail(response));
    } else {
      yield put(searchCodePortalSuccess(response));
    }
  } catch (error) {
    yield put(searchCodePortalFail(error));
  }
}
function* getSearchResult({ payload }) {
  try {
    const response = yield call(PortalService.getSearchResult, payload);
    yield put(getSearchResultSuccess(response));
  } catch (error) {
    yield put(getSearchResultFail(error));
  }
}
function* downloadFile({ payload }) {
  try {
    const response = yield call(PortalService.downloadFile, payload);
    yield put(downloadFileSuccess(response));
  } catch (error) {
    yield put(downloadFileFail(error));
  }
}
function* portalSaga() {
  yield takeEvery(SEARCH_CODE_PORTAL, searchCodePortal);
  yield takeEvery(GET_SEARCH_RESULT, getSearchResult);
  yield takeEvery(GET_CAPCHA, getCapcha);
  yield takeEvery(DOWNLOAD_FILE, downloadFile);
}

export default portalSaga;
